export interface Review {
  id: string;
  episodeId: string;
  author: string;
  avatarSeed: string;
  rating: number;
  date: string;
  content: string;
  likes: number;
  featured: boolean;
}

export const reviews: Review[] = [
  {
    id: "rv-01",
    episodeId: "ep-09",
    author: "深夜追剧人",
    avatarSeed: "深",
    rating: 5,
    date: "2026-05-04",
    content:
      "第九集的十分钟对峙戏，是我近三年看过最狠的一场群戏。没有配乐，只有对白和呼吸，但每一句都像刀。看完久久缓不过来。",
    likes: 428,
    featured: true,
  },
  {
    id: "rv-02",
    episodeId: "ep-03",
    author: "第14街的猫",
    avatarSeed: "猫",
    rating: 5,
    date: "2026-03-23",
    content:
      "第三集把整集交给回忆，是很大胆的选择，但处理得极好。那段夏天的暖色滤镜，和后面冰冷的宅邸形成了最残忍的对比。",
    likes: 356,
    featured: true,
  },
  {
    id: "rv-03",
    episodeId: "ep-04",
    author: "只看人物",
    avatarSeed: "人",
    rating: 5,
    date: "2026-03-30",
    content:
      "莉娜这条线终于被讲明白了。她不是叛逆，是一直在替别人收拾场面。索菲亚·维拉的微表情完全是影后级别。",
    likes: 297,
    featured: true,
  },
  {
    id: "rv-04",
    episodeId: "ep-08",
    author: "镜像爱好者",
    avatarSeed: "镜",
    rating: 5,
    date: "2026-04-27",
    content:
      "第八集的镜子调度太绝了。每次人物做决定，镜子里就多出一个「过去的自己」，这个设计把悔恨拍成了空间，太有想法。",
    likes: 264,
    featured: true,
  },
  {
    id: "rv-05",
    episodeId: "ep-01",
    author: "开场白控",
    avatarSeed: "白",
    rating: 4,
    date: "2026-03-09",
    content:
      "第一集节奏偏慢，但那种「所有人都装作没事」的压迫感铺得很好。信被读出来的那几秒，我直接屏住了呼吸。",
    likes: 189,
    featured: true,
  },
  {
    id: "rv-06",
    episodeId: "ep-10",
    author: "结局党",
    avatarSeed: "局",
    rating: 5,
    date: "2026-05-11",
    content:
      "大结局没有强行圆满，而是让每个人都带着伤痕继续生活。最后凯文走出宅邸不回头的那一幕，我守着字幕看完了。",
    likes: 512,
    featured: true,
  },
  {
    id: "rv-07",
    episodeId: "ep-05",
    author: "法律系影迷",
    avatarSeed: "法",
    rating: 4,
    date: "2026-04-06",
    content:
      "第三份遗嘱这一段信息量很大，第一次看以为只是推进剧情，二刷才发现前面每一集都在为它埋伏笔。细节控狂喜。",
    likes: 143,
    featured: false,
  },
  {
    id: "rv-08",
    episodeId: "ep-07",
    author: "掌声之后",
    avatarSeed: "掌",
    rating: 5,
    date: "2026-04-20",
    content:
      "第七集几乎没有对白，全靠镜头扫过每一张脸，却把人物关系讲得比任何台词都清楚。结尾卸妆那一下，太心疼了。",
    likes: 208,
    featured: true,
  },
  {
    id: "rv-09",
    episodeId: "ep-02",
    author: "餐桌观察员",
    avatarSeed: "餐",
    rating: 4,
    date: "2026-03-16",
    content:
      "用一张餐桌的座次来讲权力关系，这个设计很妙。谁被隔开、谁的位置空着，比台词直白多了。",
    likes: 121,
    featured: false,
  },
];

export const reviewsByEpisode = (episodeId: string): Review[] =>
  reviews.filter((review) => review.episodeId === episodeId);